import { create } from 'zustand';
import type { Badges, ResumableGame } from '@tg/shared';

/**
 * Menu counters (spec 2026-09-30 §1): filled by GET /api/me/badges on sign-in and by the `badges` socket event,
 * cleared on sign-out (features/social/BadgesListener). The menu shows what needs attention (2026-10-01):
 * «Friends» — friendRequests; «Messages» — unreadChats (conversations with unread messages); «Tournaments» — tourneys;
 * «Games» — unfinished solo rounds (a number) or the daily bonus / the daily quest reward (a dot); «Profile» — new achievements and moments.
 */
interface BadgesState {
  badges: Badges | null;
  set(b: Badges): void;
  clear(): void;
}

export const useBadges = create<BadgesState>()((set) => ({
  badges: null,
  set: (badges) => set({ badges }),
  clear: () => set({ badges: null }),
}));

export const selectFriendsBadge = (s: BadgesState): number => s.badges?.friendRequests ?? 0;
export const selectMessagesBadge = (s: BadgesState): number => s.badges?.unreadChats ?? 0;
export const selectTourneysBadge = (s: BadgesState): number => s.badges?.tourneys ?? 0;
export const selectAchievementsBadge = (s: BadgesState): number => s.badges?.achievements ?? 0;
export const selectDailyBadge = (s: BadgesState): boolean => s.badges?.dailyBonus ?? false;
export const selectQuestBadge = (s: BadgesState): boolean => s.badges?.quest ?? false;
const NO_GAMES: ResumableGame[] = [];
export const selectResume = (s: BadgesState): ResumableGame[] => s.badges?.resume ?? NO_GAMES;

/** the badge caps at 99: more shows as «99+» */
export const BADGE_MAX = 99;
